import {ApolloClient, ApolloLink, from, HttpLink, InMemoryCache} from "@apollo/client";
import {createUploadLink} from "apollo-upload-client";
import omitDeep from "omit-deep";
import {LocalStorageWrapper, persistCache} from "apollo3-cache-persist";
import {useKeycloak} from "@react-keycloak/web";
import {KeycloakInstance} from "keycloak-js";


const cleanTypeName = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    if (operation.variables?.file?.path) {
      operation.variables = omitDeep({...(operation.variables)}, '__typename')
    } else {
      const omitTypename = (key: any, value: any) => (key === '__typename' ? undefined : value);
      operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
    }
  }
  return forward(operation).map((data) => {
    return data;
  });
});
const authMiddleware = (authToken: any) =>
  new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    if (authToken) {
      operation.setContext({
        headers: {
          authorization: `Bearer ${authToken}`,
        },
      });
    }

    return forward(operation);
  });

const cache = new InMemoryCache({});

export const LOGIN_MODE_EXPLICIT = "explicit"

export const useAppApolloClient = (loginMode?: string, keycloak?: KeycloakInstance, initialized?: boolean) => {
  const httpLink = new HttpLink({uri: window.FRONT_CONFIG?.graphQlUrl})
  const uploadLink = createUploadLink({
    uri: window.FRONT_CONFIG?.graphQlUrl
  })
  persistCache({
    cache: cache,
    storage: new LocalStorageWrapper(window.localStorage),
    debug: window.FRONT_CONFIG.debug

  })

  console.log('LOGINMODE!!!!', loginMode)

  if (loginMode === "none") {
    if (keycloak?.authenticated) {
      //const [principal,] = usePrincipal();
      return new ApolloClient({
        link: from([cleanTypeName, authMiddleware(keycloak.token), uploadLink]),
        cache,
      });
    } else {
      return new ApolloClient({
        link: from([cleanTypeName, uploadLink]),
        cache,
      });
    }
  }

  if (initialized) {
    if (keycloak?.authenticated) {
      //const [principal,] = usePrincipal();
      return new ApolloClient({
        link: from([cleanTypeName, authMiddleware(keycloak.token), uploadLink]),
        cache,
      });
    } else {
      if (loginMode !== "explicit" && loginMode !== "none" && window.FRONT_CONFIG?.oauth?.idpHint) {
        keycloak.login({idpHint: window.FRONT_CONFIG?.oauth?.idpHint})
      }
    }
  }
  return null

};
